import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Table, Avatar, Row, Col, message, Checkbox, Tag, Tabs } from 'antd'
import util from '../../util/util'
import '../../css/users.scss'
import moment from 'moment'
import { constants } from '../../constants'
import { getFullfillments } from '../../store/action/device.action'
const { ROLE } = constants

const FullfillmentTable = (props) => {
  var history = useHistory()
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
    showSizeChanger: true,
  })
  const fetchinput = {
    metadata: { current: 1, pageSize: 20, showSizeChanger: true },
    filters: { status: 'Pending' },
    sorter: { field: 'orderDate', order: 'ascend' },
  }

  useEffect(() => {
    setPagination({
      ...props.fullfillments?.metadata,
      total: props.fullfillments?.total,
    })
  }, [props.fullfillments])

  const fetchFullfillments = (pagination, filters, sorter) => {
    console.log(pagination, filters, sorter)
    fetchinput.filters = props.filters
    fetchinput.sorter.field = sorter.field
    fetchinput.sorter.order = sorter.order
    fetchinput.metadata.current = pagination.current
    fetchinput.metadata.pageSize = pagination.pageSize
    fetchinput.metadata.showSizeChanger = pagination.showSizeChanger
    setPagination(pagination)
    props.getFullfillments(fetchinput)
  }
  // console.log(props.fullfillments,"fsdssssssssssssss")
  var fetchUsersList = (pagination, sorter) => {
    props.fetchUsers({
      companyid: props.company?._id,
      customerid: props.customer?._id,
      pagination,
      searchText: props.searchText,
      sorter,
      active: props.active,
    })
  }

  var formatdata = (data) => {
    data && data.forEach((e, i) => (e.key = e._id))
    return data
  }

  var dataSource = formatdata(props.fullfillments?.list)

  var renderName = (customer, obj) => {
    return (
      <Row className={'nameRow'}>
        <Avatar src={customer?.logo}></Avatar>
        <span>{_.upperFirst(customer.name)}</span>
      </Row>
    )
  }

  var handleRowClick = (record) =>
    history.push({ pathname: `/fulfillment/${record._id}` })
  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }

  const columns = [
    {
      title: 'Clinic',
      dataIndex: 'customer',
      render: (record, obj) => renderName(record, obj),
    },
    {
      title: 'Patient',
      dataIndex: 'patientName',
      align: 'center',
      width:'10%'
    },
    {
      title: 'Provider',
      dataIndex: 'surgeon',
      align: 'center',
      width: '15%',
      render: (provider) => provider?.name,
    },
    {
      title: 'Surgery Date',
      dataIndex: 'surgery',
      align: 'center',
      sorter: true,
      width: '8%',
      render: (surgery) =>
        surgery ? moment(surgery?.date).format('MM/DD/YYYY') : '',
    },
    {
      title: 'Devices Ordered',
      dataIndex: 'noOfDevice',
      align: 'center',
    },
    {
      title: 'Case No',
      dataIndex: 'cases',
      align: 'center',
      render: (casedata) => (casedata.casenumber ? casedata.casenumber : 'NA'),
    },
    {
      title: 'Consent',
      dataIndex: 'consent',
      align: 'center',
      render: (consent, obj) =>
        consent
          ? `Yes (${moment(obj.patientconsent).format('MM/DD/YYYY hh:mm A')})`
          : 'No',
    },
    {
      title: 'Registered',
      dataIndex: 'registered',
      align: 'center',
      render: (registered, obj) => (registered ? 'Yes' : 'No'),
    },
    {
      title: 'Fullfillment Type',
      dataIndex: 'isnew',
      align: 'center',
      render: (isnew, obj) => (isnew ? 'Reorder' : 'New'),
    },
    {
      title: 'Order Date',
      dataIndex: 'orderDate',
      defaultSortOrder: 'ascend',
      sorter: true,
      width:'13%',
      align: 'center',
      render: (date) => moment(date).format('MM/DD/YYYY hh:mm A'),
    },
    // {
    //     title: 'ACTION',
    //     align: 'center',
    //     render: (row, obj) => <a onClick={(e) => handleResetClick(e, obj)}>Reset Password</a>
    // },
  ]

  return (
    <>
      <Table
        size={'large'}
        className={'custom-table'}
        columns={columns}
        dataSource={dataSource}
        loading={props.isLoading}
        pagination={{ ...pagination, showSizeChanger: true }}
        onChange={fetchFullfillments}
        bordered={false}
        onRow={handleRow}
      />
    </>
  )
}

FullfillmentTable.propTypes = {
  fetchSurgeon: PropTypes.func.isRequired,
  surgeons: PropTypes.array,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
  isLoading: PropTypes.bool,
  selectedSurgeons: PropTypes.array,
  active: PropTypes.bool,
  user: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    users: state.user.users,
    user: state.profile.user,
    company: state.profile.company,
    sorter: state.user.sorter,
    searchText: state.user.searchText,
    active: state.user.active,
    isLoading: state.user.isLoading,
    fullfillments: state.device.fullfillments,
    filters: state.device.fullfillmentFilter,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getFullfillments: (params) => dispatch(getFullfillments(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FullfillmentTable)
